export const INVALID_RUN_ID = '#invalid-run-id';
export const UNDO_REVEALED_HIDDEN_INFORMATION = '#undo-revealed-hidden-information';
export const STALE_PROMPT = '#stale-prompt';
export const RESPONDING_TOO_QUICKLY = '#responding-too-quickly';
export const INVALID_REQUEST_ID = '#invalid-request-id';
